module.exports = __webpack_public_path__ + "img/route.d199e13e.svg";